import * as fromDatatype from '../datatype-library/index';

export interface bl_webhook_topic_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  topic_code: fromDatatype.VarcharDatatypeInterface;
  topic_name: fromDatatype.VarcharDatatypeInterface;
  topic_description: fromDatatype.TextDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;

}

export class bl_webhook_topic_hdr_RowClass
  implements bl_webhook_topic_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  topic_code: fromDatatype.VarcharDatatypeInterface;
  topic_name: fromDatatype.VarcharDatatypeInterface;
  topic_description: fromDatatype.TextDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}
